import {
  BAR_H,
  BAR_V,
  FORMULA,
  FUNNEL,
  KPI,
  LINE,
  MAP,
  MATRIX,
  PACING,
  PIE,
  TABLE,
  TEXT,
} from './panels';
import type { PanelDef } from './types';

export const PANEL_DEFS: Record<string, PanelDef> = {
  [BAR_H.type]: BAR_H,
  [BAR_V.type]: BAR_V,
  [FORMULA.type]: FORMULA,
  [FUNNEL.type]: FUNNEL,
  [KPI.type]: KPI,
  [LINE.type]: LINE,
  [MAP.type]: MAP,
  [MATRIX.type]: MATRIX,
  [PACING.type]: PACING,
  [PIE.type]: PIE,
  [TABLE.type]: TABLE,
  [TEXT.type]: TEXT,
};

export const PANEL_TYPES = Object.keys(PANEL_DEFS).sort();

export function getPanelDef(type: string): PanelDef | undefined {
  return PANEL_DEFS[type];
}

export function assertRegistryComplete(types: string[]): void {
  const expected = [...types].sort();
  const actual = PANEL_TYPES;
  const missing = expected.filter((type) => !PANEL_DEFS[type]);
  const extra = actual.filter((type) => !expected.includes(type));

  if (missing.length > 0 || extra.length > 0) {
    const parts = [];
    if (missing.length > 0) parts.push(`missing definitions for: ${missing.join(', ')}`);
    if (extra.length > 0) parts.push(`unknown definitions for: ${extra.join(', ')}`);
    throw new Error(`Panel registry does not match widget types: ${parts.join('; ')}`);
  }
}
